module.exports = __webpack_public_path__ + "img/slot_migame.b33fe5de.png";